import styled from '@emotion/styled'

const WrapperLayout = styled('div')(() => ({
  padding: `0 20px`,
}))

export default WrapperLayout
